import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_esa0om1", // Ganti dengan Service ID dari EmailJS
        "template_wtwsroq", // Ganti dengan Template ID dari EmailJS
        form.current,
        "THa6mQutNRtDitkY4" // Ganti dengan User ID dari EmailJS
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Pesan berhasil terkirim!");
          form.current.reset(); // Reset formulir setelah berhasil
        },
        (error) => {
          console.error(error.text);
          alert("Terjadi kesalahan saat mengirim pesan.");
        }
      );
  };

  return (
    <section id="contact" className="contact-section section">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>

        {/* Kontainer untuk form dan peta */}
        <div className="contact-container">
          {/* Kolom Formulir */}
          <div className="contact-form-container">
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                required
              />
              <textarea
                name="message"
                rows="5"
                placeholder="Message"
                required
              ></textarea>
              <button type="submit" className="btn btn-neon">
                Send Message
              </button>
            </form>
          </div>

          {/* Kolom Peta */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.346631345545!2d106.83050449999999!3d-6.2179379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f403a6b4363b%3A0xd3757d9844afcf6e!2sPlaza%2089!5e0!3m2!1sid!2sid!4v1747384819924!5m2!1sid!2sid"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}